import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-30f4cb39"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 0,
  class: "circuit-routing"
};
const _hoisted_2 = {
  class: "circuit-routing__header"
};
const _hoisted_3 = {
  class: "circuit-routing__eyebrow"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "这三组元件可以全部连通吗？", -1));
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "线路只能横向或纵向布置，不能交叉、共用网格，也不能穿过其他元件。", -1));
const _hoisted_6 = {
  class: "circuit-routing__legend",
  "aria-label": "需要连接的元件配对"
};
const _hoisted_7 = {
  class: "circuit-routing__symbol",
  viewBox: "-25 -25 50 50",
  "aria-hidden": "true"
};
const _hoisted_8 = ["innerHTML"];
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "circuit-routing__line",
  "aria-hidden": "true"
}, null, -1));
const _hoisted_10 = {
  class: "circuit-routing__symbol",
  viewBox: "-25 -25 50 50",
  "aria-hidden": "true"
};
const _hoisted_11 = ["innerHTML"];
const _hoisted_12 = {
  class: "circuit-routing__board-wrap"
};
const _hoisted_13 = ["viewBox"];
const _hoisted_14 = /*#__PURE__*/_createStaticVNode("<defs data-v-30f4cb39><linearGradient id=\"pcb-board\" x1=\"0\" y1=\"0\" x2=\"1\" y2=\"1\" data-v-30f4cb39><stop stop-color=\"#79b97a\" data-v-30f4cb39></stop><stop offset=\"1\" stop-color=\"#4e985e\" data-v-30f4cb39></stop></linearGradient><linearGradient id=\"pcb-copper\" x1=\"0\" y1=\"0\" x2=\"0\" y2=\"1\" data-v-30f4cb39><stop stop-color=\"#ffe08a\" data-v-30f4cb39></stop><stop offset=\"1\" stop-color=\"#c99935\" data-v-30f4cb39></stop></linearGradient><filter id=\"pcb-shadow\" x=\"-10%\" y=\"-10%\" width=\"120%\" height=\"120%\" data-v-30f4cb39><feDropShadow dx=\"0\" dy=\"3\" stdDeviation=\"2\" flood-color=\"#1d552d\" flood-opacity=\".36\" data-v-30f4cb39></feDropShadow></filter></defs>", 1);
const _hoisted_15 = ["width", "height"];
const _hoisted_16 = /*#__PURE__*/_createStaticVNode("<g class=\"circuit-routing__silk\" fill=\"none\" stroke=\"#28683b\" stroke-width=\"4\" stroke-linejoin=\"round\" data-v-30f4cb39><path d=\"M55 40v28l-27 27v148l30 30v70l28 28\" data-v-30f4cb39></path><path d=\"M74 48v31L48 105v128l28 28v83l25 25\" data-v-30f4cb39></path><path d=\"M385 40v28l27 27v148l-30 30v70l-28 28\" data-v-30f4cb39></path><path d=\"M366 48v31l26 26v128l-28 28v83l-25 25\" data-v-30f4cb39></path><path d=\"M42 290h14M384 290h14\" data-v-30f4cb39></path></g><g class=\"circuit-routing__via\" data-v-30f4cb39><circle cx=\"55\" cy=\"40\" r=\"5\" data-v-30f4cb39></circle><circle cx=\"55\" cy=\"243\" r=\"5\" data-v-30f4cb39></circle><circle cx=\"74\" cy=\"48\" r=\"5\" data-v-30f4cb39></circle><circle cx=\"385\" cy=\"40\" r=\"5\" data-v-30f4cb39></circle><circle cx=\"385\" cy=\"243\" r=\"5\" data-v-30f4cb39></circle><circle cx=\"366\" cy=\"48\" r=\"5\" data-v-30f4cb39></circle></g><g class=\"circuit-routing__mount\" data-v-30f4cb39><circle cx=\"28\" cy=\"28\" r=\"15\" data-v-30f4cb39></circle><circle cx=\"412\" cy=\"28\" r=\"15\" data-v-30f4cb39></circle><circle cx=\"28\" cy=\"412\" r=\"15\" data-v-30f4cb39></circle><circle cx=\"412\" cy=\"412\" r=\"15\" data-v-30f4cb39></circle><circle cx=\"28\" cy=\"28\" r=\"7\" data-v-30f4cb39></circle><circle cx=\"412\" cy=\"28\" r=\"7\" data-v-30f4cb39></circle><circle cx=\"28\" cy=\"412\" r=\"7\" data-v-30f4cb39></circle><circle cx=\"412\" cy=\"412\" r=\"7\" data-v-30f4cb39></circle></g>", 3);
const _hoisted_19 = {
  class: "circuit-routing__pins",
  transform: "translate(108 398)"
};
const _hoisted_20 = ["x"];
const _hoisted_21 = ["x", "y", "width", "height"];
const _hoisted_22 = ["x1", "x2", "y1", "y2"];
const _hoisted_23 = ["x1", "x2", "y1", "y2"];
const _hoisted_24 = ["points"];
const _hoisted_25 = ["transform"];
const _hoisted_26 = ["innerHTML"];
const _hoisted_27 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "circuit-routing__prompt"
}, "请判断三组配对元件能否同时连通。", -1));
const _hoisted_28 = {
  class: "circuit-routing__answers"
};
const _hoisted_29 = {
  key: 0,
  class: "circuit-routing__review"
};
const _hoisted_30 = {
  key: 1,
  class: "circuit-routing__explanation"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_AnswerButtonGroup = _resolveComponent("AnswerButtonGroup");
  return $props.data ? (_openBlock(), _createElementBlock("section", _hoisted_1, [_createElementVNode("header", _hoisted_2, [_createElementVNode("span", _hoisted_3, "第 " + _toDisplayString($props.data.questionIndex + 1) + " 题", 1), _hoisted_4, _hoisted_5]), _createElementVNode("div", _hoisted_6, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.pairs, pair => {
    return _openBlock(), _createElementBlock("div", {
      key: pair.pairId,
      class: "circuit-routing__pair"
    }, [(_openBlock(), _createElementBlock("svg", _hoisted_7, [_createElementVNode("g", {
      class: "circuit-routing__glyph",
      innerHTML: $options.glyphMarkup(pair.leftSymbol)
    }, null, 8, _hoisted_8)])), _hoisted_9, (_openBlock(), _createElementBlock("svg", _hoisted_10, [_createElementVNode("g", {
      class: "circuit-routing__glyph",
      innerHTML: $options.glyphMarkup(pair.rightSymbol)
    }, null, 8, _hoisted_11)]))]);
  }), 128))]), _createElementVNode("div", _hoisted_12, [(_openBlock(), _createElementBlock("svg", {
    class: "circuit-routing__board",
    viewBox: `0 0 ${$data.boardSize} ${$data.boardSize}`,
    role: "img",
    "aria-label": "五乘五电路布线网格"
  }, [_hoisted_14, _createElementVNode("rect", {
    x: "4",
    y: "4",
    width: $data.boardSize - 8,
    height: $data.boardSize - 8,
    rx: "20",
    fill: "url(#pcb-board)",
    stroke: "#245e34",
    "stroke-width": "3",
    filter: "url(#pcb-shadow)"
  }, null, 8, _hoisted_15), _hoisted_16, _createElementVNode("g", _hoisted_19, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(18, pin => {
    return _createElementVNode("rect", {
      key: pin,
      x: (pin - 1) * 13,
      width: "8",
      height: "28",
      rx: "1"
    }, null, 8, _hoisted_20);
  }), 64))]), _createElementVNode("rect", {
    x: $data.boardPadding,
    y: $data.boardPadding,
    width: $options.gridPixels,
    height: $options.gridPixels,
    rx: "4",
    fill: "#6faf70",
    "fill-opacity": ".5",
    stroke: "#d5ecd1",
    "stroke-width": "2"
  }, null, 8, _hoisted_21), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.gridLines, line => {
    return _openBlock(), _createElementBlock("line", {
      key: `vertical_${line}`,
      x1: $options.gridCoordinate(line),
      x2: $options.gridCoordinate(line),
      y1: $data.boardPadding,
      y2: $data.boardPadding + $options.gridPixels,
      stroke: "#d5ecd1",
      "stroke-width": "1.5"
    }, null, 8, _hoisted_22);
  }), 128)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.gridLines, line => {
    return _openBlock(), _createElementBlock("line", {
      key: `horizontal_${line}`,
      x1: $data.boardPadding,
      x2: $data.boardPadding + $options.gridPixels,
      y1: $options.gridCoordinate(line),
      y2: $options.gridCoordinate(line),
      stroke: "#d5ecd1",
      "stroke-width": "1.5"
    }, null, 8, _hoisted_23);
  }), 128)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.solutionPaths, path => {
    return _openBlock(), _createElementBlock("polyline", {
      key: `path_${path.pairId}`,
      points: $options.pathPoints(path),
      fill: "none",
      stroke: "#ffd45e",
      "stroke-width": "8",
      "stroke-linecap": "square",
      "stroke-linejoin": "miter"
    }, null, 8, _hoisted_24);
  }), 128)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.displayComponents, component => {
    return _openBlock(), _createElementBlock("g", {
      key: `${component.pairId}_${component.row}_${component.col}`,
      transform: `translate(${$options.cellCenter(component.col)}, ${$options.cellCenter(component.row)})`
    }, [_createElementVNode("g", {
      class: "circuit-routing__glyph",
      innerHTML: $options.glyphMarkup(component.displaySymbol)
    }, null, 8, _hoisted_26)], 8, _hoisted_25);
  }), 128))], 8, _hoisted_13))]), _hoisted_27, _createElementVNode("div", _hoisted_28, [(_openBlock(), _createBlock(_component_AnswerButtonGroup, {
    key: `CircuitRouting_${$props.data.questionIndex}`,
    review: $props.review,
    "review-mode": $props.reviewMode,
    options: $data.options,
    "option-labels": $data.optionLabels,
    "option-width": "164px",
    "option-both-center": false,
    onChoose: $options.onChoose
  }, null, 8, ["review", "review-mode", "options", "option-labels", "onChoose"]))]), $props.reviewMode ? (_openBlock(), _createElementBlock("div", _hoisted_29, [_createElementVNode("span", null, "正确答案：" + _toDisplayString($options.answerLabel($props.data.rightAnswer)), 1), $props.review ? (_openBlock(), _createElementBlock("span", {
    key: 0,
    class: _normalizeClass($props.review.result ? 'is-correct' : 'is-wrong')
  }, "您的答案：" + _toDisplayString($options.answerLabel($props.review.answer)), 3)) : _createCommentVNode("", true), $options.solutionPaths.length ? (_openBlock(), _createElementBlock("span", _hoisted_30, "绿色线路展示其中一种可行连接方式。")) : _createCommentVNode("", true)])) : _createCommentVNode("", true)])) : _createCommentVNode("", true);
}